export default "/crvUSD-USDC.5ee82786f7ef2fb4205e902d7a02005e.png";